import SharedResponse from "@/interfaces/SharedResponse";

export class SharedResponseService {
    private baseUrl: string;

    private createShareUrlEndpoint = '/v1/share'
    private getSharedResponseEndpoint = '/v1/share/'

    constructor(baseUrl: string) {
        this.baseUrl = baseUrl;
    }

    async createShareLink(productId: string, userId: string, question: string, answer: string): Promise<string> {
        const url = `${this.baseUrl}${this.createShareUrlEndpoint}`;

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(
                    { 
                        'user_id': userId,
                        'product_id': productId,
                        'question': question,
                        'response': answer
                    }
                ),
            });

            if (!response.ok) {
                throw new Error('Failed to create share link');
            }

            const data = await response.json();
            return data.share_link;
        } catch (error) {
            console.error('Failed to create share link:', error);
            throw new Error('Failed to create share link');
        }
    }

    async getSharedResponseById(id: string): Promise<SharedResponse> {
        const url = `${this.baseUrl}${this.getSharedResponseEndpoint}${id}`;

        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error('Failed to create share link');
            }

            const data = await response.json();
            return {
                id: data.id,
                userId: data.user_id,
                productId: data.product_id,
                question: data.question,
                response: data.response
            };

        } catch (error) {
            console.error('Failed to create share link:', error);
            throw new Error('Failed to create share link');
        }
    }
}
